import React, { useState, useCallback } from 'react'
import moment from 'moment';
import { DatePicker, Form } from 'antd-mobile';
import { date } from 'utils/constant';

const { YEAR, MONTH, DAY } = date

/**
 * 日期选择框
 * @param {
 *  item:对应的表单模板
 *  setFormInfo:向传给接口的对象中新增对应表单数据
 * } props 
 * @returns 
 */
export function BpmFormDataPicker(props) {
  const { postName, label, required, message,
    placeholder, pickerTitle, help, disabled,
    before, precision
  } = props.item
  const { setFormInfo, postInfo } = props
  // 必须是DATE类型
  const formDate = postInfo && postInfo[postName] ? new Date(postInfo[postName]) : null
  const [visible, setVisible] = useState(false)
  // const [defaultValue, setDefaultValue] = useState(new Date())

  const labelRenderer = useCallback((type, data) => {
    switch (type) {
      case YEAR:
        return data + '年'
      case MONTH:
        return data + '月'
      case DAY:
        return data + '日'
      default:
        return data
    }
  }, [])

  /** 根据precision的值，返回不同的格式 */
  const getFormat = useCallback(() => {
    switch (precision) {
      case YEAR:
        return 'YYYY'
      case MONTH:
        return 'YYYY-MM'
      case DAY:
        return 'YYYY-MM-DD'
      default:
        return 'YYYY-MM-DD'
    }
  }, [precision])

  /** 打开/关闭 选择框 */
  const handleVisitClick = (state) => {
    setVisible(state)
  }

  /**处理日期 */
  const handleDate = (date) => {
    // 判断date是否是已经格式化过的
    if (date instanceof Date) {
      return date ? moment(date).format(getFormat()) : null
    } else {
      return date
    }
  }
  return (
    < Form.Item
      name={postName}
      label={label}
      disabled={disabled}
      rules={[{ required: required, message: message }]}
      onClick={() => handleVisitClick(true)}
      help={help ? help : ''}
      trigger='onConfirm' 
    >
      <DatePicker
        //min={before ? new Date(1900, 1, 1) : new Date()}
        min={new Date(1900, 1, 1)}
        max={before ? new Date() : new Date(2100, 1, 1)}
        title={pickerTitle}
        visible={visible}
        precision={precision ? precision : 'day'}
        onClose={() => handleVisitClick(false)}
        onConfirm={value => {
          setFormInfo(postName, handleDate(value))
        }}
        renderLabel={labelRenderer}
      >
        {
          value => value
            ?
            handleDate(value)
            :
            formDate
              ?
              handleDate(formDate)
              :
              placeholder
        }
      </DatePicker>
    </Form.Item >
  )
}